import { render, staticRenderFns } from "./EventsScoredList.vue?vue&type=template&id=71922704"
import script from "./EventsScoredList.vue?vue&type=script&lang=js"
export * from "./EventsScoredList.vue?vue&type=script&lang=js"
import style0 from "./EventsScoredList.vue?vue&type=style&index=0&id=71922704&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports